import { fetchJSON } from "./utils";

export async function fetchAll(organization_id) {
  const params = {};

  params.organization_id = organization_id;

  const url = `/api/role/all`;
  return fetchJSON(url, params, null, "get", false);
}
